const StatusType = {
    getStatus(status) {
        switch (status.toString()) {
            case "0":
                return "درخواست جديد";
            case "1":
                return "رد شده";
            case "2":
                return "برگشت خورده";
            case "5":
                return "تائيد اوليه";
            case "10":
                return "تائيد نهايي";
            case "3":
                return "حذف شده";
            case "4":
                return "ارسال مجدد";
            case "11":
                return "در حالت تعلیق";
            default:
                return "درحال پيگيری";
        }
    },
};

export default StatusType;